import '.e4{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.e5{padding-left:1.5rem;}.ssr-plugin'
import '.e6{margin:1rem 0;}.ssr-plugin'
import '.e7{color:var(--gray-700);}.ssr-plugin'
import '.e8{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="e4 e5 e6 e7 e8"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
